const events = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SELECT_MODULE: 'SELECT_MODULE',
  CHANGE_SERVICE_POINT: 'CHANGE_SERVICE_POINT',
  ERROR: 'ERROR',
};

export default events;
